import React, { useRef, useState } from 'react';
import useClickOutside from '../../../common/hooks/useClickOutside';
import { useNavigate } from 'react-router-dom';

import { PickerProps } from './pickerProps';

import { Popup } from '@progress/kendo-react-popup';
import Icon from '../icon/icon';

import './picker.scss';

const Picker: React.FC<PickerProps> = ({
  list,
  links,
  linksTitle,
  handlePick,
  field,
  label,
  iconName,
  justIcon,
  anchorPosition,
  popupPosition,
  arrow,
  processing,
}) => {
  const [show, setShow] = useState<boolean>(false);

  const pickerRef = useRef<any>(null);
  const anchor = useRef<any>(null);
  const navigate = useNavigate();

  const handleClick = () => {
    if (!processing) setShow(!show);
  };

  const clickOutsideHandler = () => {
    setShow(false);
  };

  useClickOutside(pickerRef, clickOutsideHandler, 'picker-item');

  return (
    list &&
    field && (
      <div className="picker-wrapper" ref={pickerRef}>
        <div
          className={`add-button-wrapper pointer ${label ? 'label-button-wrapper' : ''} ${justIcon ? 'just-icon' : ''}`}
          onClick={handleClick}
          ref={anchor}
          style={{ cursor: processing ? 'not-allowed' : 'pointer' }}>
          {label ? label : iconName ? <Icon name={iconName} /> : show ? '-' : '+'}
          {arrow && <Icon name="fa-caret-right" />}
        </div>
        <Popup
          anchor={anchor.current}
          show={show}
          popupClass={'popup-content'}
          popupAlign={popupPosition}
          anchorAlign={anchorPosition}
          className="popup-z-index">
          {list.map((item, key) => {
            return (
              <span
                id="picker-item"
                className="picker-item pointer"
                key={key}
                onClick={() => {
                  handlePick && handlePick(item);
                  setShow(false);
                }}>
                {item.icon && <Icon name={item.icon} className="picker-item-icon" />} {item[field]}
              </span>
            );
          })}
          {linksTitle && <span className="links-title">{linksTitle}</span>}
          {links &&
            links.length > 0 &&
            links.map((link, key) => {
              return (
                <span id="picker-item" className="picker-item pointer" key={key} onClick={() => navigate(link.route)}>
                  {link.title}
                </span>
              );
            })}
        </Popup>
      </div>
    )
  );
};

export default Picker;
